import { ResidentInputFields } from "app/services/api/types/residents/models/ResidentInputFields";
import {
  alphabetsValidation,
  alphaNumericValidationWithSpace,
  numberValidation,
  requiredValidation,
} from "ui/utils/Validators";

export const nextOfKinFields = [
  {
    id: "first_name",
    name: "first_name",
    label: "First Name",
    placeholder: "Enter first name",
    isRequired: true,
    rules: {
      ...requiredValidation("First name"),
      validate: alphabetsValidation,
    },
  },
  {
    id: "last_name",
    name: "last_name",
    label: "Last Name",
    placeholder: "Enter last name",
    isRequired: true,
    rules: {
      ...requiredValidation("Last name"),
      validate: alphabetsValidation,
    },
  },
  {
    id: "relationship",
    name: "relationship",
    label: "Relationship to Resident",
    placeholder: "Enter relationship to resident",
    isRequired: true,
    rules: {
      ...requiredValidation("Relationship to Resident"),
      validate: alphabetsValidation,
    },
  },
  {
    id: "contact_number",
    name: "contact_number",
    label: "Contact No.",
    placeholder: "Enter contact no.",
    isRequired: true,
    rules: {
      ...requiredValidation("Contact No."),
      validate: numberValidation,
    },
  },
  {
    id: "address",
    name: "address",
    label: "Home Address",
    placeholder: "Enter home address",
    isRequired: true,
    rules: {
      ...requiredValidation("Home Address"),
    },
  },
];

export const GenderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "X" },
];
